// apps/client/src/services/user.ts

import { UpdateUserProfileResponse, User } from '@fsp/types';
import { apiClient } from './apiClient';

/**
 * Update user profile
 */
export const updateUserProfile = async (
  userData: Partial<User>
): Promise<UpdateUserProfileResponse> => {
  const response = await apiClient.put('/user/profile', userData);

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const errorMessage = errorData.message || 'Failed to update profile. Please try again.';
    throw new Error(errorMessage);
  }

  return response.json();
};
